'use client';

import Image from 'next/image';
import { useEffect, useState } from 'react';

export default function PostAuthorAvatar({ src, fallback }: { src: string; fallback: string }) {
  const [displaySource, setDisplaySource] = useState(src);
  useEffect(() => setDisplaySource(src), [src]);
  return <Image src={displaySource} alt="" width={36} height={36} unoptimized onError={() => {
    if (displaySource !== fallback) setDisplaySource(fallback);
  }} />;
}
